<template>
  <el-menu-item v-if="!isHasChildren" :index="menu.path" class="truncate">
    {{ menuName }}
  </el-menu-item>
  <el-submenu
    v-else
    :index="menu.path"
    :data-index="menu.path"
    :data-submenu-offset="submenuOffset"
    :popper-class="`layout-aside-submenu-popup dynamic-submenu-popup submenu-offset-${submenuOffset}`"
    :popper-append-to-body="true"
    ref="submenu"
    @show="handleSubmenuShow"
    @mouseenter.native="handleTitleMouseEnter"
  >
    <template slot="title">{{ menuName }}</template>
    <template v-for="submenu in menu.children">
      <SubMenu :menu="submenu" :key="submenu.path" v-if="!isHidden(submenu)" />
    </template>
  </el-submenu>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'SubMenu',
    props: {
      menu: Object,
    },
    data() {
      return {
        submenuOffset: 0,
        submenuMaxHeight: 0,
      }
    },
    computed: {
      ...mapGetters({
        lang: 'sys/lang',
      }),
      isHasChildren() {
        const children = this?.menu?.children
        if (children && children.length === 1 && children[0].meta?.hidden) {
          return false // 如果只有一个子元素且其meta.hidden为true，则认为没有子元素，例如收银、设置
        } else if (children && children.length > 0) {
          return true
        } else {
          return false
        }
      },
      // 计算可见子菜单数量
      visibleChildrenCount() {
        if (!this.menu?.children) return 0
        return this.menu.children.filter((child) => !this.isHidden(child)).length
      },
      menuName() {
        if (this.lang === 'en-US' && this.menu?.meta?.icon) {
          return this.menu?.meta?.icon
        }
        return this.menu?.meta?.title
      },
    },
    methods: {
      isHidden(menu) {
        return menu?.meta?.hidden
      },
      // 鼠标进入菜单项时先算好方向，弹层出现时就是正确朝向，避免先朝下再跳成朝上
      handleTitleMouseEnter() {
        this.calculateOffsetOnShow()
      },
      handleSubmenuShow() {
        this.$nextTick(() => {
          this.calculateOffsetOnShow()
          this.applyPopupMaxHeight()
        })
      },
      /**
       * 定位规则：
       * 1. 内容能在一级下方放下 → 顶对齐，不限高（避免短菜单误出滚动条）
       * 2. 会超出屏幕 → 底对齐一级，向上展开；能放下则仍不限高
       * 3. 底对齐后仍不够 → 限高并内部滑动
       */
      calculateOffsetOnShow() {
        if (!this.$refs.submenu || !this.$refs.submenu.$el) return
        const menuItemEl = this.$refs.submenu.$el.querySelector('.el-submenu__title')
        if (!menuItemEl) return
        const menuItemRect = menuItemEl.getBoundingClientRect()
        const windowHeight = window.innerHeight
        const bottomMargin = 16
        const topMargin = 10
        const itemHeight = 60
        // Element UI .el-menu--popup 默认 padding: 5px 0
        const popupPadding = 10
        const spaceBelow = windowHeight - menuItemRect.top - bottomMargin
        const spaceForBottomAlign = Math.max(itemHeight, menuItemRect.bottom - topMargin)
        const estimated = this.visibleChildrenCount * itemHeight + popupPadding

        let targetTop = menuItemRect.top
        // 0 表示不限高，避免内容刚好等于限高时出现滚动条
        let maxH = 0

        if (estimated > spaceBelow) {
          // 会超出屏幕 → 底对齐一级
          if (estimated <= spaceForBottomAlign) {
            // 底对齐后能完整放下：只上移，不限高
            targetTop = menuItemRect.bottom - estimated
            maxH = 0
          } else {
            // 底对齐仍不够：限高到可用空间，内部滑动
            maxH = spaceForBottomAlign
            targetTop = menuItemRect.bottom - maxH
          }
          if (targetTop < topMargin) {
            targetTop = topMargin
            maxH = Math.max(itemHeight, menuItemRect.bottom - topMargin)
          }
        }

        this.submenuMaxHeight = maxH > 0 ? Math.floor(maxH) : 0
        // 上限 1500 对齐 Aside 中 submenu-offset-* 的 class 范围
        const offset = Math.max(0, Math.round((menuItemRect.top - targetTop) / 10) * 10)
        this.submenuOffset = Math.min(1500, offset)
        this.applyPopupMaxHeight()
      },
      /** 仅在需要限高时写入；能放下时清掉内联限高，避免短菜单误出滚动条 */
      applyPopupMaxHeight() {
        this.$nextTick(() => {
          const submenu = this.$refs.submenu
          const popperElm = submenu && (submenu.popperElm || (submenu.$refs && submenu.$refs.menu))
          if (!popperElm || !popperElm.style) return
          if (this.submenuMaxHeight > 0) {
            popperElm.style.maxHeight = `${this.submenuMaxHeight}px`
            popperElm.style.overflowY = 'auto'
          } else {
            popperElm.style.maxHeight = ''
            popperElm.style.overflowY = ''
          }
        })
      },
    },
    mounted() {
      this.handleResize = () => this.calculateOffsetOnShow()
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize)
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
